import { render, staticRenderFns } from "./likesContent.vue?vue&type=template&id=4ba6d04a&scoped=true&"
import script from "./likesContent.vue?vue&type=script&lang=js&"
export * from "./likesContent.vue?vue&type=script&lang=js&"
import style0 from "./likesContent.vue?vue&type=style&index=0&id=4ba6d04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6d04a",
  null
  
)

export default component.exports